import { connect } from 'react-redux';
import Banner from './Banner';

const mapStateToProps = ({ siteInfo }) => ({
    title: siteInfo.title,
    visualAssistanceText: siteInfo.visualAssistanceText,
});

export default connect(mapStateToProps)(Banner);
